// ag-grid-enterprise v19.1.4
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ag_grid_community_1 = require("ag-grid-community");
var cell_1 = require("./cell");
var rowFactory = {
    getTemplate: function (config) {
        var index = config.index, collapsed = config.collapsed, hidden = config.hidden, height = config.height, outlineLevel = config.outlineLevel, s = config.s, _a = config.cells, cells = _a === void 0 ? [] : _a;
        var children = ag_grid_community_1._.map(cells, cell_1.default.getTemplate);
        return {
            name: "row",
            properties: {
                rawMap: {
                    r: index,
                    collapsed: collapsed,
                    hidden: hidden ? '1' : '0',
                    ht: height,
                    customHeight: height != null ? '1' : '0',
                    s: s,
                    customFormat: s != null ? '1' : '0'
                }
            },
            children: children
        };
    }
};
exports.default = rowFactory;



//////////////////
// WEBPACK FOOTER
// ./~/_ag-grid-enterprise@19.1.4@ag-grid-enterprise/dist/lib/exporter/files/ooxml/row.js
// module id = 761
// module chunks = 5